// Sync quantity from product-info to product-sticky-add-to-cart
(function() {
  let isSyncing = false;
  
  function syncQuantityToStickyCart() {
    console.log('[Quantity Sync] Attempting to sync quantity inputs...');
    
    // Find quantity inputs
    const productInfoInput = document.querySelector('.product-info quantity-input input[name="quantity"]');
    const stickyCartInput = document.querySelector('product-sticky-add-to-cart quantity-input input[name="quantity"]');
    
    if (!productInfoInput || !stickyCartInput) {
      console.log('[Quantity Sync] Inputs not found yet:', {
        productInfoInput: !!productInfoInput,
        stickyCartInput: !!stickyCartInput
      });
      return; // One or both don't exist yet
    }
    
    console.log('[Quantity Sync] Inputs found:', {
      productInfoValue: productInfoInput.value,
      stickyCartValue: stickyCartInput.value
    });
    
    // Check if already initialized
    if (productInfoInput.dataset.syncInitialized) {
      console.log('[Quantity Sync] Already initialized, skipping...');
      return;
    }
    
    // Mark as initialized
    productInfoInput.dataset.syncInitialized = 'true';
    console.log('[Quantity Sync] Initialized sync listeners');
    
    // Sync function that prevents infinite loops
    const syncToSticky = () => {
      if (isSyncing) {
        console.log('[Quantity Sync] Already syncing, skipping...');
        return;
      }
      if (productInfoInput.value !== stickyCartInput.value) {
        const oldValue = stickyCartInput.value;
        const newValue = productInfoInput.value;
        console.log('[Quantity Sync] Syncing quantity:', {
          from: 'product-info',
          to: 'product-sticky-add-to-cart',
          oldValue: oldValue,
          newValue: newValue
        });
        isSyncing = true;
        stickyCartInput.value = productInfoInput.value;
        // Trigger change event to update UI
        stickyCartInput.dispatchEvent(new Event('change', { bubbles: true }));
        // Also trigger input event for quantity-input component
        stickyCartInput.dispatchEvent(new Event('input', { bubbles: true }));
        setTimeout(() => {
          isSyncing = false;
          console.log('[Quantity Sync] Sync completed');
        }, 0);
      } else {
        console.log('[Quantity Sync] Values already match, no sync needed');
      }
    };
    
    // Sync from product-info to sticky-cart on input/change
    productInfoInput.addEventListener('input', syncToSticky);
    productInfoInput.addEventListener('change', syncToSticky);
    
    // Also sync when quantity selector buttons are clicked in product-info
    const productInfoSelector = productInfoInput.closest('quantity-selector');
    if (productInfoSelector) {
      const productInfoButtons = productInfoSelector.querySelectorAll('.quantity-selector__button');
      console.log('[Quantity Sync] Found', productInfoButtons.length, 'quantity selector buttons');
      productInfoButtons.forEach((button, index) => {
        button.addEventListener('click', () => {
          console.log('[Quantity Sync] Quantity button clicked:', index);
          // Use setTimeout to allow the value to update first
          setTimeout(() => {
            syncToSticky();
          }, 10);
        });
      });
    }
  }
  
  // Initialize when DOM is ready
  function init() {
    console.log('[Quantity Sync] Initializing quantity sync...');
    syncQuantityToStickyCart();
  }
  
  if (document.readyState === 'loading') {
    console.log('[Quantity Sync] DOM is loading, waiting for DOMContentLoaded...');
    document.addEventListener('DOMContentLoaded', init);
  } else {
    console.log('[Quantity Sync] DOM already ready, initializing now...');
    init();
  }
  
  // Also try to sync when sticky cart becomes visible (in case it loads later)
  const observer = new MutationObserver(() => {
    console.log('[Quantity Sync] DOM mutation detected, checking for inputs...');
    syncQuantityToStickyCart();
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();